import { classNames } from "../../../../lib/classNames"

/** The bordered box that joins a text field and the segments that trail it. */
export function segmentedFieldClassName(invalid: boolean): string {
  return classNames(
    "bg-v2-background-elevation-raised shadow-v2-input rounded-control flex select-none items-stretch overflow-hidden border",
    invalid
      ? "border-v2-border-danger border-2"
      : "border-v2-border-default hover:has-[:enabled]:border-v2-border-strong",
    "has-[:focus-visible]:ring-3 has-[:focus-visible]:ring-v2-border-focus has-[:focus-visible]:ring-offset-0",
    "not-has-[:enabled]:bg-v2-background-surface-disabled not-has-[:enabled]:border-v2-border-default-disabled"
  )
}

export const trailingSegmentClassName =
  "border-v2-border-default flex shrink-0 items-stretch border-l"

export const segmentTriggerClassName =
  "text-v2-foreground-default-weak hover:not-disabled:bg-v2-background-surface-strong h-full w-auto shrink-0 cursor-pointer gap-x-1 rounded-none border-0 bg-transparent px-2 text-body shadow-none focus-visible:ring-0"
